import React from 'react';
import CardBody from 'components/Card/CardBody';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import SimpleWysiwyg from 'components/FormTextInput/SimpleWysiwyg';
import CardWrapper from 'components/Card/CardWrapper';
import { TranslatableObjectKey } from 'hooks/redux/Translatable/useTranslatableLanguages';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  contentWrapper: {
    marginBottom: '20px',
  },
  languageTitle: {
    textTransform: 'capitalize',
  },
});

const DescriptionCard = ({ value, setValue, title, clientLanguages = [] }) => {
  const classes = useStyles();

  return (
    <CardWrapper title={title}>
      <CardBody>
        <GridContainer>
          <GridItem md={12} className={classes.contentWrapper}>
            {clientLanguages.map(lang => {
              const languageCode = lang.isoCode || lang.code;

              return (
                <div key={lang.id || languageCode}>
                  <h4 className={classes.languageTitle}>{languageCode}</h4>
                  <SimpleWysiwyg
                    handleChange={e =>
                      setValue({
                        name: 'dishDescription',
                        languageCode,
                        value: e.target.value,
                      })
                    }
                    value={
                      value?.[TranslatableObjectKey]?.[languageCode] ||
                      value?.[languageCode] ||
                      ''
                    }
                  />
                </div>
              );
            })}
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default DescriptionCard;
